import { Toast } from 'vant'
import { base64toFile } from './canvas'

// 蓝牙
export const BLUETOOTH = 'BLUETOOTH'
// 扫码
export const SCAN_CODE = 'SCAN_CODE'
// 调用相册
export const PHOTO = 'PHOTO'
// 相机
export const CAMERA = 'CAMERA'
// PDF文件
export const PDF = 'PDF'

// 当前是否在app中
export const isInApp = !!window.android

// 调用js-bridge
function JsBridge() {
  this.onShowCallback = null
  this.onHideCallback = null
  this.bluetoothCallback = []

  window.callJSAPPStatus = (result) => {
    // 如果当前是展示状态，则展示onshow方法
    if (result) {
      this.onShowCallback && this.onShowCallback()
    } else {
      this.onHideCallback && this.onHideCallback()
    }
  }
}

/**
 * 根据bridge传入的图片base64编码创建指定格式的图片文件
 * @param base64 图片的base64编码
 */
function createImage(base64) {
  const content = `data:image/jpeg;base64,${base64}`
  var result = {
    content,
    file: base64toFile(content)
  }
  console.log('createImage', result)
  return result
}

// function createPDF(base64) {
//   console.log('getPDF')
//   const content = `data:application/pdf;base64,${base64}`
//   return {
//     content,
//     file: base64toFile(content)
//   }
// }

/**
 * 调用相机
 * @param callback 回调方法
 */
JsBridge.prototype.getCamera = function(iType, callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 回调函数
  window.callJSImages = async(result) => {
    try {
      // 执行回调
      callback(await createImage(result.imageBase64))
      // 清空回调函数
      window.callJSImages = null
    } catch (error) {
      console.error(error)
    }
  }
  console.log('getAndroidCamera', iType)
  // 调用bridge方法
  try {
    window.android.getVersion()
    // console.log('getAndroidCamera', '2x')
    window.android.getAndroidCamera(iType)
  } catch (ee) {
    // console.log('getAndroidCamera', '1x')
    window.android.getAndroidCamera()
  }
}

/**
 * 调用相册
 * @param callback 回调方法
 */
JsBridge.prototype.getPhoto = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 回调函数
  window.callJSImages = async(result) => {
    // 执行回调
    callback(await createImage(result.imageBase64))
    // 清空回调函数
    window.callJSImages = null
  }
  // 调用bridge方法
  window.android.getAndroidPhoto(1)
}

/**
 * 调用文件管理器
 * @param callback 回调方法
 */
JsBridge.prototype.getPDF = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 回调函数
  window.callJSPDF = async(result) => {
    // 执行回调
    // callback(await createPDF(result.pdfBase64))
    callback(await createImage(result.imageBase64))
    // 清空回调函数
    window.callJSPDF = null
  }
  // 调用bridge方法
  window.android.getAndroidPDF(1)
}

/**
 * 调用相机，扫条形码二维码
 * @param isBarcode 是否是条形码
 * @param callback 回调方法
 */
JsBridge.prototype.scanCode = function(isBarcode, callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 先创建回调
  window.callJSCodeScan = result => {
    console.log('扫码结果是：', result)
    callback(result)
    window.callJSCodeScan = null
  }
  // 调用bridge方法
  window.android.getAndroidCodeScan(true, -1)
}

/**
 * 从设备获取数据
 * @param callback 回调方法
 */
JsBridge.prototype.getDeviceData = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 如果2.5s之内没有触发回调，则会toast
  const timer = setTimeout(() => {
    Toast('请将身份证放置在读卡器上')
  }, 6000)
  // 设备链接状态
  window.callJSBluetooth = (result) => {
    // 先清空读卡器
    clearTimeout(timer)
    // 执行回调
    callback(result)
    // 清空回调
    window.callJSBluetooth = null
  }
  // 调用bridge方法
  window.android.getAndroidBluetooth()
}

/**
 * 查看设备链接状态
 * @param callback 回调方法
 */
JsBridge.prototype.deviceConnectStatus = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 设备链接状态
  window.callJSDeviceStatus = (appstatus) => {
    // 执行回调
    callback(appstatus)
    // 清空回调
    window.callJSDeviceStatus = null
  }
  // 校验设备状态
  window.android.getAndroidDeviceStatus()
}

/**
 * 页面处于展示状态
 * @param callback 回调方法
 */
JsBridge.prototype.onShow = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  this.onShowCallback = callback
  // 默认先执行一次onshow事件
  this.onShowCallback()
}

/**
 * 页面处于隐藏状态
 * @param callback 回调方法
 */
JsBridge.prototype.onHide = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 绑定页面离开方法
  this.onHideCallback = callback
}

/**
 * 通过NFC读取设备信息
 */
JsBridge.prototype.readIdCardByNFC = function(callback) {
  if (!isInApp) {
    return
  }
  // 设备链接状态
  window.callJSBluetooth = (result) => {
    // 执行回调
    callback(result)
    // 清空回调
    window.callJSBluetooth = null
  }
  // 调用bridge方法
  window.android.readIDCardNFC()
}

/**
 * 获取当前nfc设备的设备数据
 */
JsBridge.prototype.readIDCardByOTG = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 设备链接状态
  window.callJSBluetooth = (result) => {
    // 执行回调
    callback(result)
    // 清空回调
    window.callJSBluetooth = null
  }
  // 调用bridge方法
  window.android.readIDCardByOTG()
}

/**
 * 获取当前nfc设备的设备数据
 */
JsBridge.prototype.geOtgReadType = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 调用bridge方法
  callback(window.android.geOtgReadType())
}

/**
 * 选择蓝牙设备
 */
JsBridge.prototype.chooseBluetoothDevice = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 设备链接状态
  window.callJSDeviceStatus = (result) => {
    // 执行回调
    callback(result)
    // 清空回调
    window.callJSDeviceStatus = null
  }
  // 调用bridge方法
  window.android.choiceBluetoothDevice()
}

JsBridge.prototype.getAppVersion = function(callback) {
  // 如果不在app中
  if (!isInApp) {
    return
  }
  // 调用bridge方法
  try {
    callback(window.android.getVersion())
  } catch (ee) {
    return
  }
}

export default new JsBridge()



// WEBPACK FOOTER //
// ./src/utils/bridge.js